import { render, staticRenderFns } from "./P404.vue?vue&type=template&id=a90256ce&scoped=true&"
import script from "./P404.vue?vue&type=script&lang=js&"
export * from "./P404.vue?vue&type=script&lang=js&"
import style0 from "./P404.vue?vue&type=style&index=0&id=a90256ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90256ce",
  null
  
)

export default component.exports